import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tags"];
import enviro from 'enviro';
import { computeStackTrace } from './computeStackTrace';
import { getPortalId } from './getPortalId';
import { isJasmineRunning, isLocalWithoutSentryOverride, isSeleniumRunning } from './testEnv';
import { uuid4 } from './uuid';
import http from 'hub-http/clients/noAuthApiClient';
const SENTRY_PUBLIC_KEY = '1795bb66f3b2fd780ed97652c89a4b2b';
const ignoreErrors = [/Aborting: redirection in progress/, /hub-http - .+ - (0|403|404|429)/, /failed with status (0|403|404|429)/, /IDBDatabase/gi, /IndexedDB/gi, /IDBTransaction/gi];
export class SentryApi {
  constructor(projectName) {
    this.projectName = projectName;
    this.environment = enviro.getShort();
    this.level = 'error';
    this.platform = 'javascript';
    this.logger = 'javascript';
    this.tags = {
      portalId: getPortalId(),
      hublet: enviro.getHublet(),
      project: 'unified-navigation-ui'
    };
    this.request = {
      headers: {
        'User-Agent': navigator.userAgent
      },
      url: window.location.href
    };
    const hubletSuffix = enviro.ifHublet({
      isNa1: () => '',
      isNonNa1: hublet => `-${hublet}`
    });
    const envSuffix = enviro.isProd() ? '' : 'qa';
    const queryParams = `sentry_version=7&sentry_client=raven-js%2F3.19.1&sentry_key=${SENTRY_PUBLIC_KEY}`;
    this.sentryUrl = `https://exceptions${hubletSuffix}.hubspot${envSuffix}.com/v2/api/store/?${queryParams}`;
  }
  captureMessage(message, options = {}) {
    if (ignoreErrors.some(errorMsg => errorMsg.test(message))) {
      return Promise.resolve();
    }
    if (this.shouldSkipReporting()) {
      return Promise.resolve();
    }
    const {
        tags: optionTags
      } = options,
      restOptions = _objectWithoutPropertiesLoose(options, _excluded);
    const tags = Object.assign({}, this.tags, optionTags);
    return this.send(this.sentryUrl, Object.assign({
      message,
      event_id: uuid4(),
      environment: this.environment,
      level: this.level,
      platform: this.platform,
      logger: this.logger,
      tags,
      request: this.request,
      timestamp: Date.now() / 1000
    }, restOptions));
  }
  captureException(error, options) {
    if (this.shouldSkipReporting()) {
      return Promise.resolve();
    }
    const message = error && error.message ? error.message : 'Unknown';
    const stacktrace = computeStackTrace(error);
    return this.captureMessage(message, Object.assign({
      transaction: stacktrace.stack && stacktrace.stack[0] && stacktrace.stack[0].filename ? stacktrace.stack[0].filename : undefined,
      exception: {
        values: [{
          mechanism: {
            handled: true,
            type: 'generic'
          },
          type: stacktrace.name,
          value: stacktrace.message,
          stacktrace: {
            frames: stacktrace.stack.reverse()
          }
        }]
      }
    }, options));
  }
  shouldSkipReporting() {
    return window.location.protocol === 'file:';
  }
  async send(url, data) {
    try {
      await http.post(url, {
        data,
        safeMode: true
      });
    } catch (_unused) {
      // noop
    }
  }
}
export let sentryClient;
function isSentryEnabled() {
  if (isJasmineRunning() || isSeleniumRunning() || isLocalWithoutSentryOverride()) {
    return false;
  }
  return true;
}
function getSentryClient() {
  if (!sentryClient) {
    sentryClient = new SentryApi('unified-navigation-ui');
  }
  return sentryClient;
}
function handleError(error) {
  setTimeout(() => {
    throw error;
  }, 0);
}
export function captureMessage(message, options) {
  if (!isSentryEnabled()) {
    return;
  }
  getSentryClient().captureMessage(message, options).catch(handleError);
}
export function captureException(exception, options) {
  if (!isSentryEnabled()) {
    return;
  }
  getSentryClient().captureException(exception, options).catch(handleError);
}